import { formatNumberWithComma } from '../../../../../../utils/format-numbers.utils';
import Label from '../../../../../ui/label';
import { UniformCoverageTypes } from '../../../../../../features/gms-proposal-forms/coverage/uniform-coverage/coverage-type-uniform-coverage.state';

interface Props {
    isPreview?: boolean;
    inputsByUniformCoverage: UniformCoverageTypes | null
    selectedCoverageTypeState: string | undefined
}

export default function UniformCoverage({ isPreview, inputsByUniformCoverage, selectedCoverageTypeState }: Props) {

    return (
        <div className='flex flex-col bg-white overflow-hidden'>
            <div className='p-2 flex items-center justify-between border-b border-[#186cb2]/20 bg-[#186cb2]/10'>
                <div className='space-y-1'>
                    <Label
                        label={selectedCoverageTypeState ?? ""}
                        fontSize="text-xs"
                        fontWeight={`${isPreview ? 'text-xs font-semibold text-gray-800' : 'text-white'}`}
                    />
                    {!isPreview && (
                        <p className="text-xs text-white">
                            Enter a single coverage amount that will be applied uniformly to all eligible members.
                        </p>
                    )}
                </div>
            </div>
            <div className="overflow-x-auto bg-white p-2">
                <table className="w-full border-collapse">
                    <thead>
                        <tr className="bg-gray-100 text-black">
                            <th className="border font-medium text-xs px-2 py-2 text-left">Average Salary</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr> 
                            <td className="border p-2 text-xs">{formatNumberWithComma(inputsByUniformCoverage?.fAmount ?? '')}</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div> 
    )
}
